export const iconFontAwesomeArrowsArrowsRotate = (
	<i className="fa-solid fa-arrows-rotate"></i>
);
